/* Product image loader: shows a spinner on product gallery images until they finish loading.
   Re-runs when the gallery is re-rendered (e.g. after a variant/colour change). */
(function () {
  const SELECTOR = '.product-media img.product-media__image';

  function track(img) {
    if (img.dataset.loaderTracked) return;
    img.dataset.loaderTracked = 'true';

    const wrapper = img.closest('.product-media');
    if (!wrapper) return;

    const done = () => wrapper.classList.remove('is-loading');

    if (img.complete && img.naturalWidth > 0) return;

    wrapper.classList.add('is-loading');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function scan(root) {
    root.querySelectorAll(SELECTOR).forEach(track);
  }

  scan(document);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(SELECTOR)) track(node);
        else scan(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
